/**
 * Keep only the sites the dialog actually lists. A calendar's saved site list
 * can hold sites that were later deleted or moved out of the calendar's group;
 * they never appear in the dialog, so they can't be unticked, and the apply
 * endpoint rejects the whole save if any listed site is outside the group
 * (SUP-908 / ENG-2495). Select All already dropped them; individual ticks
 * didn't.
 */
export const assignableSiteIds = (
  assignedSites: number[],
  siteOptions: { id: number }[]
): number[] => {
  const listed = new Set(siteOptions.map((site) => site.id));
  return assignedSites.filter((id) => listed.has(id));
};

const firstMessage = (value: unknown): string | null => {
  if (typeof value === "string" && value) return value;
  if (Array.isArray(value) && typeof value[0] === "string") return value[0];
  return null;
};

/** The backend's reason for a failed calendar apply, else the generic text. */
export const calendarSitesErrorMessage = (reason: unknown): string => {
  const data = (
    reason as {
      response?: {
        data?: {
          non_field_errors?: unknown;
          customer?: unknown;
          detail?: unknown;
        };
      };
    }
  )?.response?.data;
  const detail =
    firstMessage(data?.non_field_errors) ??
    firstMessage(data?.customer) ??
    firstMessage(data?.detail);
  return detail
    ? `Error updating calendar sites: ${detail}`
    : "Error updating calendar sites, please try again";
};
